/**
 * 模組頁面代碼: 1230-UI
 * 模組說明: 梯控歷史資料功能頁面
 * @module ElevCtrlHistoryContainer
 */

// ----- import from local libraries -----
import {
    React,
    PropTypes,
    connect,
    BaseComponent,
    AccessModeEnums,
} from '../../components/BaseComponent';

// ----- import from local components -----
import Header from '../../features/main-frame/components/Header';
import Footer from '../../features/main-frame/components/Footer';
//import Sidebar from '../../features/main-frame/components/Sidebar';
import ElevCtrlHistoryPage from './components/ElevCtrlHistoryPage';
import { MessageModal, MessageModalModeEnums } from '../../components/MessageModal';

// ----- import from local actions -----
import {
    fetchBuildingSelection,
} from '../../redux/actions/BuildingActions';
import {
    fetchElevCtrlHistoryList,
} from '../../redux/actions/ElevCtrlHistoryActions';

// ----- constants and enums -----
const RESPONSE_OK = 200;
const TITLE_ELEV_CTRL_HIST_SEARCH = '查詢梯控歷史記錄';

class ElevCtrlHistoryContainer extends BaseComponent {
    constructor(props) {
        super(props);
        // 創建 ref
        this.messageModalRef = React.createRef();
        this.messageModal = null;

        this.state = {
            needElevCtrlHistoryLoad: false,
            newControlCommand: false,
            message: { mode: MessageModalModeEnums.ERROR, title: '', body: ''},
        };
        this.toggleMessageModal = this.toggleMessageModal.bind(this);
    }

    toggleMessageModal(isShow, mode = MessageModalModeEnums.INFO, title = '', message = '') {
        if (this.messageModal) {
            if (isShow) {
                let body = message;
                const statusCode = message?.code || '';
                if (statusCode !== '') {
                    body = `[ ${statusCode} ] ${message.message}`;
                }
                this.setState({ message: { mode: mode, title: title, body: body }});
                this.messageModal.show();
            } else {
                this.messageModal.hide();
            }
        }
    }

    componentDidMount() {
        // 頁面所需資料初始化
        this.props.fetchBuildingSelection();
        // 預設查詢日期為當天
        const today = new Date();
        const formattedStartDate = today.toISOString().slice(0, 10) + ' 00:00:00';
        const formattedEndDate = today.toISOString().slice(0, 10) + ' 23:59:59';
        this.props.fetchElevCtrlHistoryList(0, 0, '', formattedStartDate, formattedEndDate).then(() => {
            this.setState({ needElevCtrlHistoryLoad: true });
        });
        this.messageModal = new bootstrap.Modal(this.messageModalRef.current);
    }
    
    componentDidUpdate(prevProps, prevState) {
        const socketMessage = this.props.newSocketMessage;
        if (socketMessage && prevProps.newSocketMessage !== socketMessage) {
            // 處理新的 socket 消息
            if (socketMessage && socketMessage.event === 'new_control_command') {
                this.setState({ newControlCommand: true });
            }
        }
    }

    componentWillUnmount() {
        this.toggleMessageModal(false);
    }

    render() {
        return (
            <React.Fragment>
                <Header />
                <div className="header__Placeholder"></div>
                <div className="m__wrap">
                    <div className="m__contents">
                        {/* <Sidebar /> */}
                        <ElevCtrlHistoryPage
                            {...this.props}
                            needElevCtrlHistoryLoad={this.state.needElevCtrlHistoryLoad}
                            newControlCommand={this.state.newControlCommand}
                            setNeedElevCtrlHistoryLoad={(bLoad) => this.setState({ needElevCtrlHistoryLoad: bLoad })}
                            setNewControlCommand={(bNew) => this.setState({ newControlCommand: bNew })}
                        />
                    </div>
                </div>
                <Footer />
                <MessageModal
                    ref={this.messageModalRef}
                    mode={this.state.message.mode}
                    title={this.state.message.title}
                    message={this.state.message.body}
                />
            </React.Fragment>
        );
    }
}

ElevCtrlHistoryContainer.propTypes = {
    userPermissions: PropTypes.array,
    buildingSelection: PropTypes.array,
    elevCtrlHistoryList: PropTypes.array,
    newSocketMessage: PropTypes.any,
};

ElevCtrlHistoryContainer.defaultProps = {
    userPermissions: [],
    buildingSelection: [],
    elevCtrlHistoryList: [],
    newSocketMessage: null,
};

function mapStateToProps(state) {
    return {
        userPermissions: state.access.userPermissions,
        buildingSelection: state.building.buildingSelection.data,
        elevCtrlHistoryList: state.elevCtrlHistory.elevCtrlHistoryList.data,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchBuildingSelection: () => {
            return dispatch(fetchBuildingSelection());
        },
        fetchElevCtrlHistoryList: (buildingId, elevatorId, userName, startDate, endDate) => {
            return dispatch(fetchElevCtrlHistoryList({ buildingId, elevatorId, userName, startDate, endDate }));
        },
    };    
}

export default connect(mapStateToProps, mapDispatchToProps)(ElevCtrlHistoryContainer);